import { Course, Hole, Tee } from "./types";

// Georgian Bay Club, Clarksburg ON. Par 71, 7122 yds from the back
// (Cobalt) tees. Stroke index from the Men's Handicap row on the card.
// Yardages shown are Cobalt — change here if the displayed Yds row should
// reflect a different tee.
const georgianBayHoles: Hole[] = [
  { number: 1, par: 4, si: 5, yardage: 453 },
  { number: 2, par: 4, si: 13, yardage: 377 },
  { number: 3, par: 3, si: 15, yardage: 194 },
  { number: 4, par: 4, si: 1, yardage: 418 },
  { number: 5, par: 3, si: 17, yardage: 226 },
  { number: 6, par: 4, si: 9, yardage: 440 },
  { number: 7, par: 5, si: 3, yardage: 575 },
  { number: 8, par: 4, si: 7, yardage: 452 },
  { number: 9, par: 4, si: 11, yardage: 402 },
  { number: 10, par: 4, si: 10, yardage: 445 },
  { number: 11, par: 4, si: 14, yardage: 335 },
  { number: 12, par: 3, si: 18, yardage: 176 },
  { number: 13, par: 5, si: 2, yardage: 524 },
  { number: 14, par: 4, si: 6, yardage: 441 },
  { number: 15, par: 4, si: 12, yardage: 388 },
  { number: 16, par: 4, si: 8, yardage: 466 },
  { number: 17, par: 3, si: 16, yardage: 202 },
  { number: 18, par: 5, si: 4, yardage: 608 },
];

// Georgian Bay Club — verbatim from the official card. Yardage totals
// match the printed Total column for every tee. Combo tees carry two
// colours so the indicator dot can render as a 50/50 split.
const COBALT = "#0047ab";
const GOLD = "#d4a017";
const SILVER = "#c0c0c0";
const COPPER = "#b87333";
const PEWTER = "#797679";

const georgianBayTees: Tee[] = [
  {
    id: "cobalt",
    name: "Cobalt",
    color: COBALT,
    colors: [COBALT],
    slope: 138,
    rating: 74,
    // 7122 yds
    yardages: [
      453, 377, 194, 418, 226, 440, 575, 452, 402,
      445, 335, 176, 524, 441, 388, 466, 202, 608,
    ],
  },
  {
    id: "gold",
    name: "Gold",
    color: GOLD,
    colors: [GOLD],
    slope: 135,
    rating: 72.5,
    // 6751 yds
    yardages: [
      433, 348, 205, 397, 202, 416, 542, 434, 381,
      421, 314, 153, 504, 420, 375, 443, 184, 579,
    ],
  },
  {
    id: "gold-silver",
    name: "Gold/Silver",
    color: GOLD,
    colors: [GOLD, SILVER],
    slope: 130,
    rating: 71.4,
    // 6515 yds
    yardages: [
      402, 348, 179, 397, 178, 404, 542, 413, 381,
      388, 314, 153, 504, 394, 346, 409, 184, 579,
    ],
    // Holes that borrow the SHORTER tee's yardage (Silver here). Verified
    // by comparing this combo's per-hole yardage to the pure Gold and
    // Silver rows. The other holes (2, 4, 7, 9, 11, 12, 13, 17, 18) use
    // Gold's yardage and render in gold.
    secondaryHoles: [1, 3, 5, 6, 8, 10, 14, 15, 16],
  },
  {
    id: "silver",
    name: "Silver",
    color: SILVER,
    colors: [SILVER],
    slope: 129,
    rating: 70.5,
    // 6299 yds
    yardages: [
      402, 291, 179, 374, 178, 404, 515, 413, 357,
      388, 295, 143, 484, 394, 346, 409, 174, 553,
    ],
  },
  {
    id: "silver-copper",
    name: "Silver/Copper",
    color: SILVER,
    colors: [SILVER, COPPER],
    slope: 127,
    rating: 68.5,
    // 5945 yds
    yardages: [
      360, 291, 150, 374, 149, 350, 515, 386, 357,
      340, 295, 143, 484, 345, 301, 378, 174, 553,
    ],
    // Copper-coloured holes on this combo. Other holes (2,4,7,9,11,12,
    // 13,17,18) use Silver yardage and render in silver.
    secondaryHoles: [1, 3, 5, 6, 8, 10, 14, 15, 16],
  },
  {
    id: "copper",
    name: "Copper",
    color: COPPER,
    colors: [COPPER],
    slope: 126,
    rating: 67.6,
    // 5716 yds
    yardages: [
      360, 257, 150, 350, 149, 350, 487, 386, 332,
      340, 272, 120, 462, 345, 301, 378, 151, 526,
    ],
  },
  {
    id: "copper-pewter",
    name: "Copper/Pewter",
    color: COPPER,
    colors: [COPPER, PEWTER],
    slope: 124,
    rating: 66.4,
    // 5424 yds
    yardages: [
      337, 257, 134, 350, 126, 294, 487, 366, 332,
      305, 272, 120, 462, 323, 260, 322, 151, 526,
    ],
    // Pewter-coloured holes on this combo. Copper-coloured holes are
    // 2, 4, 7, 11, 12, 13, 17, 18 — note hole 9 is pewter on this combo
    // even though its yardage matches Copper, per the official card.
    secondaryHoles: [1, 3, 5, 6, 8, 9, 10, 14, 15, 16],
  },
  {
    id: "pewter",
    name: "Pewter",
    color: PEWTER,
    colors: [PEWTER],
    slope: 118,
    rating: 65.1,
    // 5160 yds
    yardages: [
      337, 267, 134, 331, 126, 294, 458, 366, 312,
      305, 176, 93, 436, 323, 260, 322, 121, 499,
    ],
  },
];

export const mockCourses: Course[] = [
  {
    id: "georgian-bay-club",
    name: "Georgian Bay Club",
    city: "Clarksburg",
    region: "ON",
    country: "Canada",
    holes: georgianBayHoles,
    tees: georgianBayTees,
  },
];
